import React from 'react'
import { Link } from 'react-router-dom'

import TimeAgo from 'react-timeago'

class Update3 extends React.Component{



render() {

  return(
    <div>
      <h1 className="introduction-header" >Newforma ConstructEx Update 1.0</h1>
      <p className="introduction-p-italic">
      By Nathan Sellers <TimeAgo date="Oct 11, 2018" />
      </p>
        <p className="introduction-p"> Construct a new integration with the <span className="orange"> ConstructEx APIs</span>!</p>
        <p className="introduction-p"> The ConstructEx development team has been hard at work this past month and is ready to release a first for ConstructEx: <span className="blue">Project and Submittal </span>
          APIs. With these latest editions to the Newforma family of APIs you will be able to move Submittals in and out of ConstuctEx with ease and grace. If you find yourself
          with the need to get a Submittal reviewed in another system such as Plangrid or Procore you now have the tools required to write yourself a custom integration.
          Please pop over to the <Link to="/documentation"> Documentation</Link> page for more details, to jump right into the nitty gritty take a look at the
          <Link to="constructexapi"> ConstructEx API Reference.</Link>

        </p>


        <p className="introduction-p"> We of course will not be stopping here, everyday our Developers are working hard to create more powerful API resources to give
          you access to the information you need. Please visit the Updates page frequently to keep up with the most recent releases.

        </p>

      </div> )
}
}
export default Update3;



/** WEBPACK FOOTER **
 ** ./src/pages/Updates/update3.js
 **/